import { z } from 'zod';
import { OffsetQuerySchema, coercedBoolField, idField, qField } from './common';

// The only user shape a regular member is ever served: a name and a face, nothing else.
export const UserSummarySchema = z.object({
  id: idField,
  displayName: z.string(),
  avatarUrl: z.string().nullable(),
});
export type UserSummary = z.infer<typeof UserSummarySchema>;

export const UserSearchQuerySchema = OffsetQuerySchema.extend({
  q: qField,
  excludeSelf: coercedBoolField,
});
export type UserSearchQuery = z.infer<typeof UserSearchQuerySchema>;

export const UserSearchResponseSchema = z.object({
  users: z.array(UserSummarySchema),
  total: z.number().int().nonnegative(),
});
export type UserSearchResponse = z.infer<typeof UserSearchResponseSchema>;
